import Breadcrumb from "components/Common/Breadcrumb"
import TableContainer from "components/Common/DataTableContainer"
import DashboardLoader from "components/Loader/DashboardLoader"
import DeleteModal from "pages/Calendar/DeleteModal"
import React, { useMemo, useState } from "react"
import { Link } from "react-router-dom"
import {
  useGetAllUsersQuery,
  useDeleteUserMutation,
} from "store/features/users/userManagementApi"
import EditUserModal from "components/Modals/EditUserModal"

const AllUsers = () => {
  const { data: users, isLoading, refetch } = useGetAllUsersQuery()
  const [deleteUser, { isLoading: deletingUser }] = useDeleteUserMutation()

  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState(null)
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [roleFilter, setRoleFilter] = useState("")

  const showDeleteModal = id => {
    setSelectedUserId(id)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    deleteUser(selectedUserId)
    setDeleteModal(false)
  }

  const handleEditUser = user => {
    setSelectedUser(user)
    setEditModalOpen(true)
  }

  const handleUserUpdate = () => {
    refetch()
    setEditModalOpen(false)
  }

  // Filter users based on role
  const filteredUsers = useMemo(() => {
    if (!users) return []

    return users.filter(user => {
      return !roleFilter || user.role === roleFilter
    })
  }, [users, roleFilter])

  const getRoleBadge = role => {
    const roleConfig = {
      admin: { color: "danger", text: "Admin" },
      developer: { color: "primary", text: "Developer" },
      client: { color: "success", text: "Client" },
      manager: { color: "warning", text: "Manager" },
    }
    const config = roleConfig[role] || { color: "secondary", text: role }
    return `<span class="badge bg-${config.color}">${config.text}</span>`
  }

  const getImageUrl = imagePath => {
    if (!imagePath) return "/static/images/default-avatar.png"
    return `https://qwikbistro.shop${imagePath}`
  }

  const columns = useMemo(
    () => [
      // {
      //   header: "ID",
      //   accessorKey: "id",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => `#${row.original.id}`,
      // },
      // {
      //   header: "Image",
      //   accessorKey: "image",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => (
      //     <div className="d-flex align-items-center">
      //       <img
      //         src={getImageUrl(row.original.image)}
      //         alt={row.original.nickname}
      //         className="rounded-circle"
      //         style={{ width: "40px", height: "40px", objectFit: "cover" }}
      //       />
      //     </div>
      //   ),
      // },
      {
        header: "Image",
        accessorKey: "image",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="d-flex align-items-center justify-content-center">
            {row.original.image ? (
              <img
                src={row.original.image}
                alt={row.original.nickname}
                className="rounded-circle"
                style={{ width: "40px", height: "40px", objectFit: "cover" }}
              />
            ) : (
              <i
                className="fas fa-user-circle text-secondary"
                style={{ fontSize: "40px" }}
              ></i>
            )}
          </div>
        ),
      },

      // {
      //   header: "Name",
      //   accessorKey: "nickname",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => (
      //     <div>
      //       <div className="fw-semibold">{row.original.nickname}</div>
      //       <small className="text-muted">{row.original.personal_email}</small>
      //     </div>
      //   ),
      // },

      {
        header: "Name",
        accessorKey: "nickname",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => row.original.nickname || "N/A",
      },
      // {
      //   header: "Email",
      //   accessorKey: "personal_email",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => row.original.personal_email || "N/A",
      // },

      // {
      //   header: "Role",
      //   accessorKey: "role",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => (
      //     <div
      //       dangerouslySetInnerHTML={{
      //         __html: getRoleBadge(row.original.role),
      //       }}
      //     />
      //   ),
      // },

      // {
      //   header: "Phone",
      //   accessorKey: "phone",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => row.original.phone || "N/A",
      // },

      // {
      //   header: "Role",
      //   accessorKey: "role",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => row.original.role || "N/A",
      // },
      // {
      //   header: "Account Status",
      //   accessorKey: "account_status",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => (
      //     <div
      //       style={{
      //         color: row.original.account_status ? "green" : "red",
      //       }}
      //     >
      //       {row.original.account_status ? "Active" : "Disabled"}
      //     </div>
      //   ),
      // },
      {
        header: "Permission",
        accessorKey: "crm_permissions",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          const permissions = row.original.crm_permissions

          if (!permissions || permissions.length === 0) return "N/A"

          const labelMap = {
            qwik_it: "Qwik It",
            qwik_medic: "Qwik Medic",
            qwik_bistro: "Qwik Bistro",
          }

          return (
            <ol style={{ paddingLeft: "18px", margin: 0 }}>
              {permissions.map((crm, index) => (
                <li key={index}>{labelMap[crm] || crm}</li>
              ))}
            </ol>
          )
        },
      },
      {
        header: "Position",
        accessorKey: "position",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => row.original.position || "N/A",
      },
      // {
      //   header: "Address",
      //   accessorKey: "address",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => row.original.address || "N/A",
      // },
      // {
      //   header: "Join Date",
      //   accessorKey: "joining_date",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => row.original.joining_date || "N/A",
      // },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="d-flex align-items-center gap-1">
            <button
              onClick={() => handleEditUser(row.original)}
              className="btn btn-primary btn-sm"
            >
              <i className="fas fa-edit"></i> 
            </button>
            <button
              className="btn btn-danger btn-sm"
              onClick={() => showDeleteModal(row.original.id)}
            >
              <i className="fas fa-trash"></i>
              {/* {deletingUser ? "Deleting..." : "Delete"} */}
            </button>
          </div>
        ),
      },
    ],
    [deletingUser]
  )

  if (isLoading) {
    return <DashboardLoader />
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb title="Users" breadcrumbItem="All Users" />

        <div className="mb-3 gap-5 d-flex justify-content-end align-items-center">
          <div className="d-flex gap-2 align-items-center">
            <div>
              {/* <label className="form-label me-2">Filter by Role:</label> */}
              <select
                className="form-select d-inline-block"
                style={{ width: "auto" }}
                value={roleFilter}
                onChange={e => setRoleFilter(e.target.value)}
              >
                <option value="">All Users</option>
                <option value="admin">Admin</option>
                <option value="project_manager">Project Manager</option>
                <option value="developer">Developer</option>
                <option value="marketing">Marketing</option>
                {/* <option value="client">Client</option> */}
                <option value="hr">HR</option>
              </select>
            </div>
            {/* <button className="btn btn-light" onClick={() => setRoleFilter("")}>
              <i className="fas fa-times"></i> Clear
            </button> */}
          </div>

          <Link to="/create-user" className="btn btn-primary">
            <i className="fas fa-plus me-2"></i>User
          </Link>
        </div>

        <TableContainer
          columns={columns}
          data={filteredUsers}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder="Search Users..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />

        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteUser}
          loader={deletingUser}
          onCloseClick={() => setDeleteModal(false)}
        />

        {selectedUser && (
          <EditUserModal
            isOpen={editModalOpen}
            toggle={() => setEditModalOpen(false)}
            user={selectedUser}
            onUserUpdate={handleUserUpdate}
          />
        )}
      </div>
    </div>
  )
}

export default AllUsers
